<div class="dash-header">
  <div class="dash-header-left">
    <h1 class="dash-title">Consolidated Dashboard</h1>
    <span class="dash-date-display">{{date}}</span>
  </div>
  <div class="dash-header-right">
    <label class="date-label">Date</label>
    <input type="date" class="date-input" [(ngModel)]="date" (change)="init()" [max]="today" />
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="init(true)" [disabled]="is_loading">Refresh</button>
  </div>
</div>


<div class="folder-toolbar" *ngIf="!is_loading && !error && companies.length">
  <span>Click a company folder to view its banks or games.</span>
  <div class="folder-actions">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="setAllExpanded(true)">Expand all</button>
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="setAllExpanded(false)">Collapse all</button>
  </div>
</div>

<div class="company-scope" *ngIf="!is_loading && companies.length">
  <span class="scope-label">Included companies</span>
  <span class="company-pill" *ngFor="let company of companies">
    {{company.name}}<span *ngIf="company.currency && company.currency !== 'none'"> · {{company.currency}}</span>
  </span>
</div>

<div class="loading-bar" *ngIf="is_loading"><div class="loading-bar-inner"></div></div>
<div class="alert alert-danger" *ngIf="error">{{error}}</div>
<div class="alert alert-info" *ngIf="!is_loading && !error && companies.length === 0">No assigned companies are available.</div>

<div class="dash-card" *ngFor="let section of sections">
  <div class="dash-card-header">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
      <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h11A1.5 1.5 0 0 1 15 2.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 13.5zM2.5 2a.5.5 0 0 0-.5.5V6h12V2.5a.5.5 0 0 0-.5-.5zM14 7H2v6.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5z"/>
    </svg>
    <h2>{{section.title}}</h2>
  </div>
  <div class="dash-table-wrap">
    <table class="dash-table">
      <thead>
        <tr>
          <th class="col-name">{{section.itemTitle}}</th>
          <th class="col-name">Company</th>
          <th class="col-name">Currency</th>
          <th class="col-num" *ngFor="let column of section.columns" [class.col-highlight]="column.highlight">{{column.title}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="is_loading">
          <td class="state-cell" [attr.colspan]="section.columns.length + 3"><span class="state-text">Loading...</span></td>
        </tr>
        <tr *ngIf="!is_loading && !error && !companyGroups[section.source]?.length">
          <td class="state-cell" [attr.colspan]="section.columns.length + 3"><span class="state-text">No Data Available</span></td>
        </tr>
        <ng-container *ngIf="!is_loading && !error">
          <ng-container *ngFor="let group of companyGroups[section.source]">
            <tr class="company-folder-row">
              <td class="col-name" colspan="2">
                <button type="button" class="company-folder" (click)="toggleCompany(section, group)"
                  [attr.aria-expanded]="isExpanded(section, group)"
                  [attr.aria-label]="group.name + ' — ' + section.title">
                  <span class="folder-chevron" [class.expanded]="isExpanded(section, group)" aria-hidden="true">▸</span>
                  <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
                    <path d="M3 7V5a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7h18" />
                  </svg>
                  <span>{{group.name}}</span>
                  <span class="folder-count">{{group.rows.length}} items</span>
                </button>
              </td>
              <td class="col-name currency-code">{{group.rows.length ? totalCurrency(group.rows) : (currencyLabel(group.currency) || '—')}}</td>
              <td class="col-num" *ngFor="let column of section.columns" [class.col-highlight]="column.highlight">
                {{total(group.rows, column.key) | number: '1.2-2'}}
              </td>
            </tr>
            <ng-container *ngIf="isExpanded(section, group)">
              <tr class="company-detail-row" *ngFor="let row of group.rows">
                <td class="col-name detail-name">{{row.title}}<small *ngIf="row.status != null && row.status != 1" class="text-muted"> · Inactive</small></td>
                <td class="col-name company-name">{{row.company_name}}</td>
                <td class="col-name currency-code">{{currencyLabel(row.currency) || '—'}}</td>
                <td class="col-num" *ngFor="let column of section.columns" [class.col-highlight]="column.highlight">
                  {{(row[column.key] ?? 0) | number: '1.2-2'}}
                </td>
              </tr>
              <tr *ngIf="!group.rows.length">
                <td class="state-cell" [attr.colspan]="section.columns.length + 3"><span class="state-text">No data for this company.</span></td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
      <tfoot *ngIf="!is_loading && rows(section).length">
        <tr>
          <td class="col-name foot-label" colspan="2">Total</td>
          <td class="col-name currency-code">{{totalCurrency(rows(section))}}</td>
          <td class="col-num" *ngFor="let column of section.columns" [class.col-highlight]="column.highlight">
            {{total(rows(section), column.key) | number: '1.2-2'}}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>

<app-credit-collection [compact]="true" [consolidated]="true" [refreshKey]="is_loading"></app-credit-collection>

<app-dashboard-withdrawals [date]="date" [consolidated]="true" [refreshKey]="is_loading"></app-dashboard-withdrawals>
